import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Testimonials',
    href: '/testimonials'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-soft py-3' : 'bg-white/95 backdrop-blur-md py-5'}`} data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="flex justify-between items-center" data-id="element-150">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" aria-label="Crownehealth Home" data-id="element-151">
            <div className="w-8 h-8 rounded-full bg-chocolate flex items-center justify-center text-cream font-serif font-bold text-xl group-hover:bg-gold transition-colors" data-id="element-152">
              C
            </div>
            <span className="font-serif font-bold text-2xl text-chocolate tracking-tight" data-id="element-153">
              Crownehealth
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-154">
            <ul className="flex items-center gap-8" data-id="element-155">
              {navLinks.map(link => <li key={link.name} data-id="element-156">
                  <Link to={link.href} className={`font-medium transition-colors text-sm uppercase tracking-wider ${location.pathname === link.href ? 'text-gold' : 'text-chocolate/80 hover:text-gold'}`} data-id="element-157">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
            <Link to="/contact" className="bg-chocolate text-cream px-6 py-2.5 rounded-full font-medium hover:bg-gold hover:text-white transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-158">
              Book Appointment
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-chocolate hover:bg-nude/50 rounded-lg transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle mobile menu" aria-expanded={isMobileMenuOpen} data-id="element-159">
            {isMobileMenuOpen ? <X size={24} data-id="element-160" /> : <Menu size={24} data-id="element-161" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-162">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-nude overflow-hidden shadow-soft-lg" data-id="element-163">
            <ul className="px-4 py-6 flex flex-col gap-4" data-id="element-164">
              {navLinks.map(link => <li key={link.name} data-id="element-165">
                  <Link to={link.href} className={`block font-medium text-lg py-2 border-b border-nude/30 ${location.pathname === link.href ? 'text-gold' : 'text-chocolate'}`} data-id="element-166">
                    {link.name}
                  </Link>
                </li>)}
              <li className="pt-4" data-id="element-167">
                <Link to="/contact" className="block w-full text-center bg-chocolate text-cream px-6 py-3 rounded-full font-medium hover:bg-gold transition-colors" data-id="element-168">
                  Book Appointment
                </Link>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}